import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormField } from 'core/components/form';
import { lookupsJson } from '@ourbranch/lookups';
import { Grid } from '@material-ui/core';

import useStyles from './counties-autocomplete.styles';

const usCountiesByState = lookupsJson.usCountiesByState;

const CountiesAutocomplete = ({ state, setValues, xs = 12, id, ...props }) => {
  const classes = useStyles();

  const options = useMemo(() => {
    if (!state || !usCountiesByState[state]) {
      // Default to IL for now until we start limiting farm offers to IL, IN, and MO
      return usCountiesByState.IL.map((county) => ({
        text: county,
        id: county,
        value: county
      }));
    }

    return usCountiesByState[state].map((county) => ({
      text: county,
      id: county,
      value: county
    }));
  }, [state]);

  const handleSelection = useCallback(
    (_, selection) => {
      if (!selection) {
        return;
      }

      const { text } = selection;

      if (setValues) {
        setValues(id, text || '');
      }
    },
    [setValues]
  );

  return (
    <Grid xs={xs} className={classes.field}>
      <FormField
        type="autocomplete"
        name={id}
        id={id}
        mode="light"
        label="County"
        helperText="Type to narrow down your county search"
        options={options}
        allowUserInput={false}
        freeSolo={false}
        fast={false}
        onSelection={handleSelection}
        permissions={{ isLicensedAction: false }}
        {...props}
      />
    </Grid>
  );
};

CountiesAutocomplete.propTypes = {
  state: PropTypes.string.isRequired,
  setValues: PropTypes.func,
  xs: PropTypes.number
};

CountiesAutocomplete.defaultProps = {
  setValues: null
};

export default CountiesAutocomplete;
